const InitialAddress = {
    placeId: null,
    latitude: "",
    longitude: "",
    addressType: null,
    address: null,
    number: "",
    neighborhood: null,
    complement: "",
    city: null,
    zipCode: "",
    description: "",
    attachId: null,
    imgScr: undefined,
    file: undefined,
    visitable: false,
    patrollable: false,
    availabilityStartTime: "",
    availabilityEndTime: "",
};

export default InitialAddress;